export default __webpack_public_path__ + "static/media/monitore_black.8d693a3e.png";